import React from 'react';
import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import { ProductParameterExpansionProps } from './root-props';
import { ProductParameterValueOfImageBrowser, productConfigurationTypePriceMultiplier } from '../../../../product/model';
import { priceToString } from '../../../../../core';

export const ProductParameterExpansionImageBrowser = (props: ProductParameterExpansionProps<ProductParameterValueOfImageBrowser>) => {
    const noneLabels = ['none', 'brak'];
    let values = props.values.map(it => ({ ...it }));
    values.push(...values.splice(values.findIndex(it => noneLabels.includes(it.label.toLowerCase())), 1));
    const typePriceMultiplier = props.parameter.key === 'fabrics'
        ? productConfigurationTypePriceMultiplier(props.product.configuration)
        : 1;
    const select = (value: ProductParameterValueOfImageBrowser) => {
        if (props.parameter.multiple) {
            if (!props.valueSelected || !props.valueSelected.length)
                props.valueSelect([value], true);
            else if (props.valueSelected.some(it => it.key === value.key))
                props.valueSelect(props.valueSelected.filter(it => it.key !== value.key) as ProductParameterValueOfImageBrowser[], true);
            else if (noneLabels.includes(value.label.toLowerCase()) || props.valueSelected.some(it => noneLabels.includes(it.label.toLowerCase())))
                // If None option is clicked or selected when other option is clicked: keep only the clicked option selected
                props.valueSelect([value], true);
            else
                props.valueSelect([...props.valueSelected, value] as ProductParameterValueOfImageBrowser[], true);
        } else {
            props.valueSelect([value], false);
        }
    };
    return <Grid container>
        {values.filter(it => !it.disabled).map((value, key) => <Grid
            item xs={4}
            key={key}
            container
            direction='column'
            alignItems='center'
            className={classNames({ 'imagebrowser-item': true, 'imagebrowser-item--selected': props.valueSelected && props.valueSelected.some(it => it.key === value.key) })}
            onClick={() => select(value)}
        >

            <img src={value.imageUrl || 'https://i-love-png.com/images/no-image_7279.png'} className='imagebrowser-image' />

            <b className='imagebrowser-label'>{value.label}</b>
            <div>{priceToString(value.price * typePriceMultiplier, props.product.currency)}</div>
        </Grid>)}
    </Grid>;
};